import styled from "@emotion/native";
import Text from "../Text";

export const Container = styled.View({
	// flex: 1,
});

export const Prefix = styled(Text)({
	marginTop: 26,
	marginHorizontal: 20,
	textAlign: "center",
});

export const Summary = styled(Text)({
	marginTop: 7,
	marginBottom: 13,
	paddingHorizontal: 10,
	textAlign: "center",
});

export const Priorities = styled.View({
	marginTop: 38,
	flexDirection: "row",
	flexWrap: "wrap",
	justifyContent: "space-between",
	marginBottom: 12,
});

export const Priority = styled.View({
	display: "flex",
	flexDirection: "row",
	alignContent: "flex-start",
	alignItems: "center",
	justifyContent: "flex-start",
	paddingHorizontal: 20,
});

export const TopPriority = styled.View({
	display: "flex",
	flexDirection: "column",
	alignContent: "center",
	alignItems: "center",
	justifyContent: "center",
	paddingHorizontal: 20,
	marginHorizontal: "auto",
	marginBottom: 20,
});

export const PriorityDescriptionContainer = styled.View({
	paddingHorizontal: 20,
});

export const PriorityLabel = styled(Text)({
	textAlign: "center",
	fontWeight: "700",
});

export const PriorityIcon = styled.Image({
	width: 60,
	height: 60,
	marginVertical: 12,
	marginHorizontal: 12,
	alignSelf: "center",
	resizeMode: "contain",
});

export const TopPriorityIcon = styled.Image({
	width: 100,
	height: 100,
	alignSelf: "center",
	resizeMode: "contain",
});

export const PriorityLevel = styled(Text)({
	textAlign: "center",
	marginLeft: "auto",
});

export const TopPriorityLevel = styled(Text)({
	textAlign: "center",
	marginVertical: 12,
});
